<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>{{ $t('reset_title')}}</h1>
        <span>
          {{ $t('reset_hint')}}
        </span>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <v-layout column>
          <form @submit.prevent="resetPassword(email)">
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">{{ error }}</v-alert>
            </v-flex>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required
              ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn color="primary" type="submit">{{ $t('reset_submit')}}</v-btn>
            </v-flex>
          </form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<i18n>
  {
    "de": {
      "reset_title" : "Passwort zurücksetzen",
      "reset_hint" : "Nach dem Absenden erhalten Sie eine Email zum Zurücksetzen ihres Passwortes.",
      "reset_submit" : "Passwort zurücksetzen"
    },
    "en": {
      "reset_title" : "Reset password",
      "reset_hint" : "An email to reset your password will be sent to your email address.",
      "reset_submit" : "Reset password"
    }
  }
</i18n>

<script>
import { mapActions } from "vuex";
import { api } from "@/store/modules/users";

import firebase from "firebase";

export default {
  data() {
    return {
      email: "",
      password: "",
      alert: false
    };
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.userSignIn,
      api.actions.userSignInWithGoogle
    ]),
    resetPassword(emailAddress) {
      firebase
        .auth()
        .sendPasswordResetEmail(emailAddress)
        .then(function() {
          console.log("Password Reset Successfull");
        })
        .catch(function(error) {
          console.log("Password Reset failed", error);
        });

      this.$router.push("/signin");
    }
  },
  computed: {
    error() {
      return {};
      //return this.$store.state.error;
    },
    loading() {
      return {};
      //return this.$store.state.loading;
    }
  },
  watch: {
    user(value) {
      //console.log(value)
      if (value !== null && value !== undefined) {
        this.$router.push("/");
      }
    },
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        //this.$store.commit("setError", null);
      }
    }
  }
};
</script>
